export const LANGUAGES = {
  Python: {
    id: "python-skill",
    rating: 4,
    display: "Python",
  },
  "C#": {
    id: "csharp-skill",
    rating: 4,
    display: "C#",
  },
  Java: {
    id: "java-skill",
    rating: 4,
    display: "Java",
  },
  "C++": {
    id: "cpp-skill",
    rating: 3,
    display: "C++",
  },
  JavaScript: {
    id: "javascript-skill",
    rating: 4,
    display: "JavaScript",
  },
  TypeScript: {
    id: "typescript-skill",
    rating: 3,
    display: "TypeScript",
  },
  HTML: {
    id: "html-skill",
    rating: 4,
    display: "HTML",
  },
  CSS: {
    id: "css-skill",
    rating: 4,
    display: "CSS",
  },
  SQL: {
    id: "sql-skill",
    rating: 3,
    display: "SQL",
  },
};

export const FRAMEWORKS_LIBRARIES = {
  ".NET": {
    rating: 4,
  },
  Blazor: {
    rating: 4,
  },
  WPF: {
    rating: 3,
  },
  React: {
    rating: 4,
  },
  "React Native": {
    rating: 3,
  },
  Angular: {
    rating: 3,
  },
  Bootstrap: {
    rating: 4,
  },
  Flask: {
    rating: 3,
  },
};

export const TOOLS = {
  Git: {
    rating: 3,
  },
  Docker: {
    rating: 3,
  },
  Kubernetes: {
    rating: 3,
  },
  AWS: {
    rating: 3,
  },
  Azure: {
    rating: 3,
  },
  GCP: {
    rating: 3,
  },
  Linux: {
    rating: 3,
  },
  "SQL Server": {
    rating: 3,
  },
  PostgreSQL: {
    rating: 3,
  },
  MySQL: {
    rating: 3,
  },
  SQLite: {
    rating: 3,
  },
  MongoDB: {
    rating: 3,
  },
};

export const MACHINE_LEARNING = {
  PyTorch: {
    rating: 3,
  },
  TensorFlow: {
    rating: 3,
  },
  Keras: {
    rating: 3,
  },
  "Scikit-Learn": {
    rating: 3,
  },
  Transformers: {
    rating: 3,
  },
  NumPy: {
    rating: 3,
  },
  Pandas: {
    rating: 3,
  },
};
